import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Switch } from '../../../common/html/switch'
import { PopupAction } from '../../../common/popup/PopupAction'
import { selectLoading, selectSettings } from '../store/slice'
import { updateAlertSettings } from '../store/thunk'
import { TooltipEmail } from '../TooltipEmail'
import { Checkbox } from './../../../common/html/checkbox/index'

export const SettingItem = ({
  isIndustry,
  settingKey,
  settingEmailKey,
  title,
  description,
  additionalDesc,
}) => {
  const dispatch = useDispatch()

  const checkedAlert = useSelector(selectSettings(settingKey))
  const checkedEmail = useSelector(selectSettings(settingEmailKey))
  const isLoadingUpdate = useSelector(selectLoading('updateSettings'))

  const [isShowPopupAlert, setIsShowPopupAlert] = useState(false)
  const [isShowPopupEmail, setIsShowPopupEmail] = useState(false)

  const openPopupAlert = () => {
    setIsShowPopupAlert(true)
  }

  const closePopupAlert = () => {
    setIsShowPopupAlert(false)
  }

  const openPopupEmail = () => {
    setIsShowPopupEmail(true)
  }

  const closePopupEmail = () => {
    setIsShowPopupEmail(false)
  }

  const dispatchUpdateSettings = (data) => {
    dispatch(updateAlertSettings(data))
  }

  const handleChangeAlert = () => {
    if (isLoadingUpdate) return

    if (!checkedAlert) {
      dispatchUpdateSettings({ [settingKey]: true, [settingEmailKey]: true })
    } else {
      openPopupAlert()
    }
  }

  const handleChangeEmail = () => {
    if (isLoadingUpdate) return

    if (!checkedEmail) {
      dispatchUpdateSettings({ [settingEmailKey]: true })
    } else {
      openPopupEmail()
    }
  }

  const handleSubmitPopupAlert = () => {
    dispatchUpdateSettings({ [settingKey]: false })
    closePopupAlert()
  }

  const handleSubmitPopupEmail = () => {
    dispatchUpdateSettings({ [settingEmailKey]: false })
    closePopupEmail()
  }

  return (
    <>
      <Element className="my2 dFlex alignItemsCenter justifyContentBetween gap2">
        <Element>
          <Switch
            title={title}
            isI18n
            checked={checkedAlert}
            onChange={handleChangeAlert}
            className="fw600"
          />
          <Element style={{ color: '#3A414B', marginTop: 4 }}>
            <Translate value={description} />{' '}
            {additionalDesc ? additionalDesc : null}
          </Element>
        </Element>
        <Element>
          <TooltipEmail
            children={(isEmailActive) => (
              <Checkbox
                title="alertSetting.SEND_EMAILS"
                isI18n
                checked={checkedEmail}
                onChange={handleChangeEmail}
                allowChange={checkedAlert && isEmailActive}
                isCheckOnClickText
                appendStyle={{ padding: '4px 0' }}
              />
            )}
          />
        </Element>
      </Element>

      <PopupAction
        isShow={isShowPopupAlert}
        title="alertSetting.DISABLE_ALERTS"
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: closePopupAlert,
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleSubmitPopupAlert,
        }}
        handleClose={closePopupAlert}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate
              value={
                isIndustry
                  ? 'alertSetting.DISABLE_ALERTS_INDUSTRY'
                  : 'alertSetting.DISABLE_ALERTS_MACRO'
              }
            />
          </Element>
        </Element>
      </PopupAction>

      <PopupAction
        isShow={isShowPopupEmail}
        title="alertSetting.DISABLE_EMAILS"
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: closePopupEmail,
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleSubmitPopupEmail,
        }}
        handleClose={closePopupEmail}
      >
        <Element className="pb1">
          <Element style={{ color: '#3A414B' }}>
            <Translate value="alertSetting.DISABLE_EMAILS_CONFIRM" />
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}
